import { Spinner } from '@frontend/elements';
import { CommonMessage } from '@frontend/lang';
import { LuCircleCheck, LuCircleX } from 'react-icons/lu';

import { PlatformObjectBadgeMapper } from '../modal/platform-object-badge/platform-object-badge-mapper.component';
import usePermissionsList from './permissions-list.controller';

export interface PermissionsListProps {
    entityType?: string;
    entityId?: string;
    /** Owning account for the entity; defaults to URL `:accountId`, then `currentAccount`. */
    accountId?: string;
}

const PermissionsList = (props: PermissionsListProps) => {
    const viewProps = usePermissionsList(props);
    if (!viewProps.mappedPermissions) return <Spinner />;
    const resultArray = Array.from(viewProps.mappedPermissions!.result.entries());
    const uidArray = Array.from(viewProps.mappedPermissions!.mappedUids.entries());

    return (
        <div className='bg-background-surface outline-border-default flex w-full flex-col items-start justify-between gap-3 self-stretch rounded-xl outline outline-offset-[-1px]'>
            <h3 className='p-4 text-xl font-semibold'>{CommonMessage.OBJECTS.PERMISSION.PLURAL}</h3>

            {resultArray
                .filter(([key]) => !!viewProps.entityTypePermissions[key])
                .map(([key, value]) => {
                    if (Object.keys(value).length === 0) return null;

                    return (
                        <div
                            className='text-foreground-default border-border-default flex w-full flex-col gap-1 border-b px-4 py-3'
                            key={key}>
                            <div className='grid grid-cols-12 gap-4'>
                                <div className='col-span-2 font-semibold'>{key.charAt(0).toUpperCase() + key.slice(1).replace(/_/g, ' ')}</div>
                                {viewProps.entityTypePermissions[key].map((right, i) => (
                                    <div
                                        key={i}
                                        className='col-span-1 font-medium'>
                                        {right}
                                    </div>
                                ))}
                            </div>

                            {uidArray.map(([uidKey, uidValue]) => {
                                const rightsMap = viewProps.entityTypePermissions[key];
                                return uidValue.map((id) => {
                                    if (!(Object.values(value) as string[][]).some((v) => v.includes(id))) return null;
                                    return (
                                        <div
                                            key={id}
                                            className='grid grid-cols-12 gap-4'>
                                            <div className='col-span-2'>
                                                {id === '*' ? (
                                                    '*'
                                                ) : (
                                                    <PlatformObjectBadgeMapper
                                                        id={id}
                                                        type={uidKey.endsWith('_id') ? uidKey : uidKey + '_id'}
                                                    />
                                                )}
                                            </div>
                                            {rightsMap?.map((right) => {
                                                if (value[right]?.includes(id) || (Object.keys(value).includes('*') && id === '*')) {
                                                    return (
                                                        <div
                                                            key={right}
                                                            className='col-span-1'>
                                                            <LuCircleCheck className='text-status-success text-lg' />
                                                        </div>
                                                    );
                                                } else {
                                                    return (
                                                        <div
                                                            key={right}
                                                            className='col-span-1'>
                                                            <LuCircleX className='text-status-danger text-lg' />
                                                        </div>
                                                    );
                                                }
                                            })}
                                        </div>
                                    );
                                });
                            })}
                        </div>
                    );
                })}
        </div>
    );
};

export default PermissionsList;
